<div id="map"></div>

<div class="map-overlay">
  <form [formGroup]="filterForm">
    <!-- Fish Types -->
    <div class="filter-section">
      <h4>Fish Types</h4>
      <div>
        <label>
          <input type="checkbox" [value]="heatMap" [checked]=true (change)="toggleLayer('heatMap', $event)">
          heatMap
        </label>
      </div>
      <div formArrayName="selectedFishTypes">
        <label *ngFor="let fishType of fishTypes">
          <input type="checkbox"
                 [value]="fishType.fish_name"
                 [checked]="filterForm.get('selectedFishTypes')?.value?.includes(fishType.fish_name)"
                 (change)="updateFishTypes(fishType.fish_name, $event)" />
          {{ fishType.fish_full_name }}
        </label>
      </div>
    </div>

    <!-- Date Range -->
    <div class="filter-section" formGroupName="dateRange">
      <h4>Date Range</h4>
      <div>
        <label>
          Start:
          <input type="date" formControlName="start">
        </label>
        <label>
          End:
          <input type="date" formControlName="end">
        </label>
      </div>
    </div>

    <!-- Temperature -->
    <div class="filter-section" formGroupName="temperature">
      <h4>Temperature (°F)</h4>
      <div>
        <label>
          Min:
          <input type="number" formControlName="min" min="0" max="100">
        </label>
        <label>
          Max:
          <input type="number" formControlName="max" min="0" max="100">
        </label>
      </div>
    </div>

    <!-- Wind Speed -->
    <div class="filter-section" formGroupName="windSpeed">
      <h4>Wind Speed (mph)</h4>
      <div>
        <label>
          Min:
          <input type="number" formControlName="min" min="0" max="100">
        </label>
        <label>
          Max:
          <input type="number" formControlName="max" min="0" max="100">
        </label>
      </div>
    </div>

    <!-- Wind Direction -->
    <div class="filter-section">
      <h4>Wind Direction</h4>
      <select formControlName="windDirection">
        <option value="" selected>Any</option>
        <option *ngFor="let direction of windDirections" [value]="direction">
          {{ direction }}
        </option>
      </select>

      <!-- Tide -->
      <h4>Tide</h4>
      <div>
        <label *ngFor="let tideState of tideStates">
          <input type="checkbox"
                 [value]="tideState"
                 [checked]="filterForm.get('tide')?.value?.includes(tideState)"
                 (change)="updateTides(tideState, $event)" />
          {{ tideState }}
        </label>
      </div>

      <h4>Trip</h4>
      <select formControlName="trip_id">
        <option value="">Any</option>
        <option *ngFor="let fishingTrip of allFishingTrips" [ngValue]="fishingTrip">
           {{ fishingTrip.trip_id }} - {{ fishingTrip.start_time | date:'shortDate' }}
        </option>
      </select>
    </div>

    <!-- Weather Conditions -->
    <div class="filter-section">
      <h4>Weather Conditions</h4>
      <div>
        <label *ngFor="let condition of weatherConditions">
          <input type="checkbox"
                 [value]="condition.short_forecast"
                 [checked]="filterForm.get('conditions')?.value?.includes(condition.short_forecast)"
                 (change)="updateConditions(condition.short_forecast, $event)" />
          {{ condition.short_forecast }}
        </label>
      </div>
    </div>
  </form>
</div>
